import { useState, useEffect, useCallback } from "react";
import { ITEMS_PER_PAGE } from "../../../constants";
import { showErrorToast, getAllDuplicateSubmissions } from "../../../helpers";
import { useLoader } from "stm-frontend-library";
import {getSelectedJournalIds} from "../../../helpers/journals";

const useScreenedManuscripts = ({ isActiveTab }) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const [fetchParams, setFetchParams] = useState({
    currentPage: 0,
    searchTerm: ''
  });

  const { showLoader, hideLoader } = useLoader();

  const fetchData = useCallback(async () => {
    try {
      showLoader();
      setError(false);

      const selectedJournalIds = await getSelectedJournalIds();

      const { currentPage, searchTerm } = fetchParams;
      let reports, total;
      ({ data: { reports =[], total = 0 } = {} } = await getAllDuplicateSubmissions(
        currentPage * ITEMS_PER_PAGE + 1,
        ITEMS_PER_PAGE,
        searchTerm,
        selectedJournalIds
      ));
      setData(reports);
      setPageCount(Math.ceil(total / ITEMS_PER_PAGE));
    } catch (err) {
      showErrorToast();
      setError(true);
    } finally {
      hideLoader();
    }
  }, [fetchParams]);

  useEffect(() => {
    if (isActiveTab) {
      fetchData();
    }
  }, [fetchData, isActiveTab]);

  const updateFetchParams = (newParams) => {
    setFetchParams(prev => ({
      ...prev,
      ...newParams,
      currentPage: newParams.currentPage !== undefined ? newParams.currentPage : prev.currentPage
    }));
  };

  return {
    data,
    error,
    pageCount,
    currentPage: fetchParams.currentPage,
    searchTerm: fetchParams.searchTerm,
    setSearchTerm: (term) => updateFetchParams({ searchTerm: term, currentPage: 0 }),
    setCurrentPage: (page) => updateFetchParams({ currentPage: page }),
    fetchData
  };
};

export default useScreenedManuscripts;
